import { useRouter } from 'next/compat/router';

import type { AccountMenu, AccountMenuItem } from 'src/concierge/contract';
import { useIsAccountEnabled } from 'src/hooks/use-is-account-enabled';
import { useHeader } from 'src/dispensary/core-menu/components/header/use-header';
import type { useUserButton } from 'src/dispensary/core-menu/components/header/user-button/use-user-button';

type UserButtonReturn = ReturnType<typeof useUserButton>;

export function useAccountMenu(userButton: UserButtonReturn): AccountMenu | undefined {
  const router = useRouter();
  const isAccountEnabled = useIsAccountEnabled();
  const { trackEvent } = useHeader();
  const { isUserLoggedIn, loggedInRoutes } = userButton;

  if (!isAccountEnabled) {
    return undefined;
  }

  // Empty items signals "logged out" to the remote — it gates account UI on items.length.
  if (!isUserLoggedIn) {
    return { items: [] };
  }

  const items: AccountMenuItem[] = loggedInRoutes
    .filter((route) => !route.hide)
    .map((route) => ({
      label: route.label,
      onSelect: () => {
        trackEvent(route.trackingLabel ?? route.label);
        void router?.push(route.href);
      },
    }));

  return { items };
}
